export enum QueryKeys {
  getBillingProfile = 'getBillingProfile',
  getBillingPlans = 'getBillingPlans',
  getInvoices = 'getInvoices',
  getBillingUsage = 'getBillingUsage',
  getCreditLedger = 'getCreditLedger',
  getSubscriptions = 'getSubscriptions',
}
